import React from 'react';
import { Route,  NavLink , BrowserRouter as Router, Switch} from 'react-router-dom';
import { NavHashLink as Link } from 'react-router-hash-link';

import { GitHub } from '@material-ui/icons';
import { Facebook } from '@material-ui/icons';
import { Twitter } from '@material-ui/icons';
import { LinkedIn } from '@material-ui/icons';
import Homeing from '../image/siam4.png'
import { useEffect } from 'react';


const Footer = (props) => {

    return (
        <div id={props.id} style={{background: '#000'}}>


                <div className='footer-social'>
                    <Router>
                        <ul>
                        <li><a href = 'https://github.com/Siam456'><GitHub fontSize='large' className='github' target="_blank" /></a></li>
                            <li><a href = 'https://www.facebook.com/profile.php?id=100005289167762'><Facebook fontSize='large' className='facebook' target="_blank" /></a></li>
                            <li><a href = 'https://twitter.com/Hasibul58142472'><Twitter fontSize='large' className='twitter' target="_blank" /></a></li>
                          
                        </ul>
                    </Router>
                    
                </div>

            <p style={{color: '#ff4800',
        fontSize: '17px',
        fontStyle: 'normal', paddingBottom: '55px'
        }}>Designed and developed by © Hasibul Hasan</p>
            
        </div>
    );
};

export default Footer;